import { appendLocaleSources } from '../../hooks/useTranslate'
import ModelPresenter from '../../api/modelPresenter'

appendLocaleSources({
  [ModelPresenter.urn]: {
    page: {
      title: 'Модель',
    },
    modal: {
      title: {
        create: 'Создать модель',
        update: 'Обновить модель',
      },
    },
    action: {
      create: 'Создать модель',
    },
    message: {
      confirmDelete: `Вы действительно хотите удалить узел?`,
    },
  },
}, 'ru')


